/*
 * Tandy Club — member status / join funnel + form router. The page has up to two
 * Shopify forms inside .tandy-club, in block order: [0] Join Tandy Club, [1] Share
 * Birthday. Both start hidden (CSS); this script reveals the right one per visitor:
 *   - Logged out: buttons show; "Join now" reveals the Join form and scrolls to it.
 *   - Logged in, NOT a member: log-in button hidden, Join form auto-revealed.
 *   - Logged in, member, no birthday yet: show the Share Birthday form (the whole
 *     status block stays hidden — the birthday callout above it is gated separately
 *     by tandy-club-gate.js via show_for="member-nobirthday").
 *   - Logged in, member, birthday on file: nothing here — block and both forms hidden.
 * Membership is read from the shared Yotpo SDK module (window.TandyClub); whether a
 * birthday is on file is server-provided (window.tcHasBirthday, from the
 * facts.birth_date metafield).
 */
(function () {
  'use strict';
  if (window.__tcStatusInit) return; // loaded once per section; run once per page
  window.__tcStatusInit = true;

  // In the theme editor the forms stay visible (CSS) so every block is selectable —
  // don't let the router hide them there.
  if (window.Shopify && window.Shopify.designMode) return;

  var root = document.querySelector('[data-tc-status]');
  if (!root) return;

  var wrapper = root.closest('.tandy-club');
  var loginBtn = root.querySelector('[data-tc-login]');
  var joinBtn = root.querySelector('[data-tc-join]');

  function isFormEmbed(el) {
    var t = el.tagName ? el.tagName.toLowerCase() : '';
    return t.indexOf('-') > -1 && t.indexOf('form') > -1;
  }
  // The Shopify form wrappers inside .tandy-club, in DOM (block) order:
  // [0] = Join Tandy Club, [1] = Share Birthday.
  function formWrappers() {
    if (!wrapper) return [];
    return [].slice.call(wrapper.querySelectorAll('*'))
      .filter(isFormEmbed)
      .map(function (el) { return el.closest('.shopify-block') || el; });
  }

  var showJoin = false, showBday = false;
  function applyForms() {
    var f = formWrappers();
    if (f[0]) f[0].style.display = showJoin ? '' : 'none';
    if (f[1]) f[1].style.display = showBday ? '' : 'none';
  }
  // Re-apply for a few seconds — the Shopify Forms embeds hydrate after load.
  applyForms();
  var ticks = 0, iv = setInterval(function () { applyForms(); if (++ticks > 60) clearInterval(iv); }, 150);
  function setForms(join, bday) { showJoin = join; showBday = bday; applyForms(); }

  function scrollTo(el) {
    if (el && el.scrollIntoView) { try { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { el.scrollIntoView(); } }
  }

  function isMember(d) {
    if (!d || typeof d !== 'object') return false;
    if (d.isOptIn === true || d.isMember === true) return true;
    if (typeof d.pointsBalance === 'number' && d.pointsBalance > 0) return true;
    if (d.actionHistoryItems && d.actionHistoryItems.length) return true;
    if (d.pointRedemptions && d.pointRedemptions.length) return true;
    if (d.vipTier && d.vipTier.name) return true;
    return false;
  }

  // Logged out: both forms stay hidden until the shopper taps "Join now".
  if (root.getAttribute('data-logged-in') !== 'true') {
    if (joinBtn) joinBtn.addEventListener('click', function () { setForms(true, false); scrollTo(formWrappers()[0]); });
    return;
  }

  // Logged in: no login/join buttons. The status block starts hidden server-side.
  if (loginBtn) loginBtn.hidden = true;
  if (joinBtn) joinBtn.hidden = true;

  var TC = window.TandyClub;
  if (!TC || typeof TC.customer !== 'function') return; // can't tell — fail safe (all hidden)

  function decide(d) {
    if (isMember(d)) {
      // Member: keep the status block hidden. Show the Share Birthday form only if
      // they haven't set a birthday yet; otherwise nothing here.
      root.style.display = 'none';
      setForms(false, !window.tcHasBirthday);
    } else {
      // Logged-in non-member: show the block and the Join form.
      root.style.display = '';
      setForms(true, false);
    }
  }
  TC.customer().then(decide).catch(function () {});
  // Re-route when the SDK module broadcasts late-arriving member data — a member
  // briefly mis-shown the join state flips to the member state without a reload.
  document.addEventListener('tandyclub:customer-updated', function (e) { decide(e.detail); });
})();
